import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import AuthorService from '../../services/AuthorService';
import AOS from 'aos';
import FullCalendar from '@fullcalendar/react';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import listPlugin from '@fullcalendar/list';
import AvatarDefault from './default-avatar.png';
import 'aos/dist/aos.css';
import './search-category.css';
import { UsersService } from '../../services/user';
import $ from "jquery";

import {
  HeaderShelf,
  ShelfFeaturedBanner,
  ShelfRecentReadings,
  ShelfYouMightLike,
  SidebarRoundedIcons,
  IaBot,
  IaBotReadingList,
  Categories,
  Card,
  Menu,
  CoinsAndBadges,
  Webview,
  OfflineTooltip,
  OfflineMessageView,
  ArchiveCategories
} from '../../components';
import { Utils } from '../../utils/utils';
export default class ViewSearchCategory extends Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();
    this.customizedRef = React.createRef();

    this.state = {
      "courses": null,
      "user": null,
      "active_project": null,
      "customization": null,
      "active_tab": null,
      "dates_expanded_list": [Utils.localeDate(new Date())],
      "avatarFile": null,
      "avatarUrl": null,
      "api_context": null,
      "books": null,
      "category": null,
      "current_page": 1,
      "total_pages": 1,
      "loading_books": true,
      "authors": []
    }

    this.onUpdateProfile = this.onUpdateProfile.bind(this);
  }

  componentWillMount() {
    this.redirectToLogin();
  }

  redirectToLogin() {
    var user = UsersService.getUser();
    if (user === null) {
      window.location = window.location.origin + window.location.pathname + "#/login";
    } else {
      this.continueRequests();
    }
  }

  continueRequests() {
    this.getSearchCategory();
    this.getBooks(this.props.match.params.page || 1);
    this.getApiContext();
    this.redirectToTab();
    this.getUser();
    AOS.init({
      // anchorPlacement: 'top-bottom'
      offset: -50
    });
    this.setState({
      "active_tab": this.getRole().graduacao ? "study" : "courses"
    })
  }

  async getApiContext() {
    const response = await fetch("./api_context.json");
    const config = await response.json();
    this.setState({
      "api_context": config
    })
  }

  async getBooks(page = 1) {
    this.setState({ "loading_books": true });
    
    // Carregar autores e livros em paralelo
    const [authors, books] = await Promise.all([
      AuthorService.loadAuthors(),
      Sdk.Api.dynamic.bridge(`/cms/v1.1/managed/content/available?include_properties=true&include_entities=true&any_entity=${this.props.match.params.uid}&page=${page}&page_size=50`)
    ]);

    // Adicionar autor usando o AuthorService
    const booksWithAuthors = books.result.map(book => ({
      ...book,
      author: this.getBookAuthor(book, authors)
    }));

    this.setState({
      "books": booksWithAuthors,
      "current_page": books.current_page,
      "total_pages": books.total_pages,
      "authors": authors,
      "loading_books": false
    })
  }

  getBookAuthor = (book, authors) => {
    // Primeiro tentar buscar autor nas properties
    let author = book.properties?.find(p => 
      p.name === "Autor" || 
      p.name === "autor" || 
      p.name === "Author" || 
      p.name === "AUTOR"
    )?.value;
    
    // Se não encontrou nas properties, usar a lógica baseada em entities
    if (!author && book.entities && authors.length) {
      author = AuthorService.updateContentAuthor(book, authors);
    }
    
    // Fallbacks adicionais
    if (!author || author === 'Autor não disponível') {
      author = book.author || 
               book.properties?.find(p => p.name.toLowerCase().includes('autor'))?.value ||
               'Autor não informado';
    }
    
    return author;
  }

  async getSearchCategory() {
    var schema = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/available?type=category`);
    var category = schema.find(cat => cat.name === "Categorias");
    var categories = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/uid/${category.uid}/items/tree`);

    this.setState({
      "category": categories.find(item => item.uid === this.props.match.params.uid)
    })
  }

  getRole() {
    var roles = Sdk.Api.authorization.user.roles;

    return {
      "graduacao": roles.filter(role => role.type === "Viewer").length > 0,
      "cursos_livres": roles.filter(role => role.type === "LearningViewer").length > 0
    }
  }

  redirectToTab() {
    var tab = Utils.getUrlParam("tab");
    if (tab !== null) {
      this.setState({
        "active_tab": tab
      })
    }
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.page !== this.props.match.params.page) {
      this.getBooks(this.props.match.params.page || 1);
    }
  }

  componentWillUnmount() {

  }


  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  async getUser() {
    // var userDetails = await UsersService.getUserDetails();
    var userDetails, avatar;
    
    if (Utils.recoverBridge(`/auth/v1.0/user/me`) !== null) {
      userDetails = Utils.recoverBridge(`/auth/v1.0/user/me`);
      avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);

      this.setState({
        "user": {
          ...(userDetails || {}),
          avatar,
        }
      });
    }
    
    userDetails = await Utils.bridgeAndStore(`/auth/v1.0/user/me`, null, 'GET');

    // var userDetails = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    if (userDetails.detail.name.search("Guest") > -1) {
      this.signOut();
    }
    avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);
    this.setActiveProject(userDetails.projects);

    this.setState({
      "user": {
        ...(userDetails || {}),
        avatar,
      }
    });
  }

  setActiveProject(projects) {
    var activeProjectUid = UsersService.getActiveProjectUid();

    if (activeProjectUid !== null) {
      var activeProject = projects.find(project => project.uid === activeProjectUid);
      Sdk.authorization.setActiveProject(activeProject)
      this.setState({
        "active_project": activeProject
      });

      this.setCustomization(activeProject)
    };
  }

  async setCustomization(activeProject) {
    var customizationConnector = activeProject.connectors.find(connector => connector.type === "Customization_1");
    
    if (window.localStorage.getItem(`connector-${customizationConnector.uid}`)) {
      this.setState({
        "customization": JSON.parse(window.localStorage.getItem(`connector-${customizationConnector.uid}`)).configuration.configs
      });
    };

    if (customizationConnector !== undefined) {
      var connector = await UsersService.getConnector(customizationConnector.uid);
      this.setState({
        "customization": connector.configuration.configs
      });
    }
  }

  onClick(type, uid) {
    window.location = window.location.origin + window.location.pathname + "#/" + type + "/" + uid;
  }

  async onUpdateProfile () {
    const { avatarFile, user } = this.state;
    const formData = new FormData();

    if (!avatarFile || !user) return;

    formData.append('profile', avatarFile);

    await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/me/thumb`, formData, "PUT")
    .then(() => {
      this.setState({ 
        active_tab: 'study',
        user: { 
        ...user, avatar: URL.createObjectURL(avatarFile)
      }});
    })
    .catch(err => {
      console.log(err);
    })
  };

  redirectTo(path) {
    // Se o path contém âncora para explore-acervo, fazer scroll
    if (path.includes('#explore-acervo')) {
      window.location.hash = '/';
      setTimeout(() => {
        // Tentar múltiplos seletores possíveis
        const selectors = [
          '.rdp-react-template-component-archive-categories',
          '[data-testid="explore-acervo"]',
          '.archive-categories',
          '.explore-acervo',
          'h2:contains("Explore todo o acervo")',
          '.rdp-react-template-view-biblioteca-explore'
        ];
        
        let exploreSection = null;
        for (const selector of selectors) {
          exploreSection = document.querySelector(selector);
          if (exploreSection) break;
        }
        
        if (exploreSection) {
          exploreSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          // Fallback: scroll para baixo na página
          window.scrollTo({ top: 800, behavior: 'smooth' });
        }
      }, 300);
    } else {
      window.location = window.location.origin + window.location.pathname + "#" + path;
    }
  }

  getImageUrl(uid) {
    var url = `${Sdk.Api.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb?image_options=width:200&api_env=${Sdk.Api.enviroment}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization.credential.accessToken}`;

    return url;
  }

  onPageChange(page) {
    window.location.hash = `#/search/category/${this.props.match.params.uid}/${page}`;
  }

  render() {
    var _this = this;
    const {
      user,
      books,
      category,
      current_page,
      total_pages,
      loading_books
    } = this.state;
    
    const { name, first_name, last_name } = (user || { detail: {}}).detail;

    return (<div className="rdp-react-template-view-search-category">

      <div
        className="rdp-react-template-view-search-category-header"
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          right: "0px",
          width: "100%",
          height: "100px",
          zIndex: 1
        }}
      >
        <HeaderShelf
          onSignOut={() => { this.signOut() }}
          onEditClick={() => {
            window.location.hash = 'perfil';
          }}
          name={user && user.detail && user.detail.name.split(" ")[0]}
          level="Nível 1"
          coins={this.state.coins}
          coinsLabel="BV Coins"
          onCoinsClick={() => this.onCoinsClick()}
          avatar={user && user.avatar ? user.avatar : undefined}
          onSearchClick={() => this.setState({"render_ai_search": true})}
          renderSearch={false}
        />
      </div>

      <div
        className="rdp-react-template-view-search-category-sidebar"
        style={{
          width: "50px",
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "0px"
        }}
      >
        <SidebarRoundedIcons/>
      </div>

      <div
        className="rdp-react-template-view-search-category-main"
        style={{
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "50px",
          right: "0px",
          overflowX: "hidden",
          overflowY: "auto"
        }}
      >
        <div className="rdp-react-template-view-search-category-breadcrumb">
          <button className="rdp-react-template-view-search-category-breadcrumb-item" onClick={() => this.redirectTo("/")}>
            <div className="rdp-react-template-view-search-category-breadcrumb-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path fill="#084c8a" d="M25.16,13.82L15.59,5.51c-.34-.29-.84-.29-1.18,0L4.84,13.83c-.37.32-.41.89-.09,1.26.17.19.41.31.67.31h2.37v8.41c0,.49.4.9.9.9h3.38c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-5.93h3.95v5.93c0,.49.4.9.9.9h3.33c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-8.41h2.53c.49,0,.9-.4.9-.9,0-.26-.11-.51-.31-.68ZM22.01,14.46c-.49,0-.9.4-.9.9v8.41h-3.26v-5.93c0-.5-.4-.9-.9-.9,0,0,0,0,0,0h-4.02c-.49,0-.9.4-.9.9v5.93h-3.3v-8.41c0-.49-.4-.9-.9-.9h-2.31L15,6.23l9.48,8.23h-2.47Z"></path></svg>
            </div>
            <span className="rdp-react-template-view-search-category-breadcrumb-item-label">Biblioteca</span>
          </button>
          <span className="rdp-react-template-view-search-category-breadcrumb-chevron"></span>
          <span 
            className="rdp-react-template-view-search-category-breadcrumb-category clickable"
            onClick={() => this.redirectTo("/#explore-acervo")}
          >
            Categorias
          </span>
          <span className="rdp-react-template-view-search-category-breadcrumb-chevron"></span>
          <span className="rdp-react-template-view-search-category-breadcrumb-category">{category !== null ? category.name : "Carregando..."}</span>
        </div>
        <div className="rdp-react-template-view-search-category-items">
          {loading_books ? (
            Array.from({length: 12}, (_, index) => (
              <div key={index} className="rdp-react-template-view-search-category-item skeleton">
                <div className="rdp-react-template-view-search-category-item-cover skeleton-cover"></div>
                <div className="rdp-react-template-view-search-category-item-title skeleton-title"></div>
                <div className="rdp-react-template-view-search-category-item-edition skeleton-edition"></div>
              </div>
            ))
          ) : (
            books && books.map(function (book, index) {
              return <div
                className={`rdp-react-template-view-search-category-item`}
                key={book.uid}
                onClick={() => _this.redirectTo(`/book/${book.uid}`)}
              >
                <img
                  className="rdp-react-template-view-search-category-item-cover blur"
                  src={_this.getImageUrl(book.uid)}
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="rdp-react-template-view-search-category-item-title">
                  {book.name}
                </div>
                <div className="rdp-react-template-view-search-category-item-title" style={{marginTop: '10px', fontWeight: '1000', fontSize: '10px', height: "28px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                  {book.author}
                </div>
                <div className="rdp-react-template-view-search-category-item-edition">
                  {book.edition}
                </div>
              </div>
            })
          )}
        </div>
        
        {total_pages > 1 && (
          <div className="rdp-react-template-view-search-category-pagination">
            <button 
              className="rdp-react-template-view-search-category-pagination-btn left"
              disabled={current_page === 1}
              onClick={() => _this.onPageChange(current_page - 1)}
            >
              Anterior
            </button>
            
            <div className="rdp-react-template-view-search-category-pagination-pages">
              {(() => {
                const maxPages = Math.min(5, total_pages);
                let startPage = Math.max(1, current_page - Math.floor(maxPages / 2));
                let endPage = Math.min(total_pages, startPage + maxPages - 1);
                
                if (endPage - startPage + 1 < maxPages) {
                  startPage = Math.max(1, endPage - maxPages + 1);
                }
                
                const pages = [];
                for (let i = startPage; i <= endPage; i++) {
                  pages.push(i);
                }
                
                return pages.map(page => (
                  <button
                    key={page}
                    className={`rdp-react-template-view-search-category-pagination-page ${current_page === page ? 'active' : ''}`}
                    onClick={() => _this.onPageChange(page)}
                  >
                    {page}
                  </button>
                ));
              })()}
            </div>
            
            <button 
              className="rdp-react-template-view-search-category-pagination-btn right"
              disabled={current_page === total_pages}
              onClick={() => _this.onPageChange(current_page + 1)}
            >
              Próxima
            </button>
          </div>
        )}
      </div>

    </div>);
  }
}
